export const CONSTANTS = {
  AUTH_RESULT: 'auth-result',
  LAST_RATING_DATE: 'last-rating',
  LAST_ANTRAG_CREATION_DATE: 'last-antrag-creation',
  LOGIN_DATA: 'login-data',
  PASSWORD_KEY: 'pass',
  PIN_KEY: 'pin',
  PRIVACY_SCREEN_KEY: 'privacy-screen',
  SAVE_BIOMETRIC_KEY: 'biometric',
  SAVE_LASTUNLOCKMODE_KEY: 'LastUnlockMode',
  SAVE_TELEMETRY_KEY: 'telemetry',
  SECURE_STORAGE_NAME: 'ebeihilfe',
  USERDATA: 'user-data',
};
